import { ChatProviderType } from '../../../../domain/chat/models/ChatProviderType';
import { NexusChatSession } from '../../../../domain/chat/models/ChatSession';
import { ChatDocument } from '../../../../domain/documents/models/ChatDocument';
import { NexusConversationDto } from '../dtos/responses/NexusConversationDto';
import { NexusFileRecordDto } from '../dtos/responses/NexusFileRecordDto';


const toTimestamp = (value: string | number): number => {
    if (typeof value === 'number') {
        return value;
    }

    const timestamp = new Date(value).getTime();
    return Number.isNaN(timestamp) ? 0 : timestamp;
};

const mapFileRecordDtoToChatDocument = (dto: NexusFileRecordDto, chatId: string): ChatDocument => ({
    id: dto.documentId,
    chatId,
    name: dto.fileName,
    createdOn: toTimestamp(dto.uploadedAt),
    userId: '', // Nexus doesn't provide userId for documents, so this will be left empty or can be set to a default value
    tokens: 0, // Nexus doesn't provide token count, so this will be set to 0 or can be calculated if needed
    size: 0,
});

export interface MappedNexusConversation {
    session: NexusChatSession;
    documents: ChatDocument[];
}

export const mapNexusConversationDtoToModel = (dto: NexusConversationDto): MappedNexusConversation => {
    const fileSearchDocuments = dto.fileSearchDocuments.map((document) => mapFileRecordDtoToChatDocument(document, dto.id));
    const codeInterpreterDocuments = dto.codeInterpreterDocuments.map((document) =>
        mapFileRecordDtoToChatDocument(document, dto.id),
    );

    return {
        session: {
            id: dto.id,
            userId: dto.userId,
            title: dto.title,
            providerType: ChatProviderType.Nexus,
            createdDate: toTimestamp(dto.createdAt),
            modifiedDate: toTimestamp(dto.updatedAt),
            agentId: dto.agentId,
            isCodeInterpreterEnabled: dto.isCodeInterpreterEnabled,
            isFileSearchEnabled: dto.isFileSearchEnabled,
            metadata: dto.metadata,
        },
        documents: [...fileSearchDocuments, ...codeInterpreterDocuments],
    };
};
